import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import toast from 'react-hot-toast';

const Register = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    gender: 'Male',
    phone_number: '',
    email: '',
    password: '',
    confirm_password: '',
  });
  const [loading, setLoading] = useState(false);
  const { register } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirm_password) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      await register(formData);
      toast.success('Account created successfully');
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.detail || 'Registration failed. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6 lg:px-8 py-12">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-2xl font-light tracking-tight text-gray-900">
            Create account
          </h1>
          <p className="mt-3 text-sm text-gray-400">
            Already have an account?{' '}
            <Link to="/login" className="text-gray-900 hover:text-gray-600 transition">
              Sign in
            </Link>
          </p>
        </div>

        {/* Form */}
        <form className="space-y-5" onSubmit={handleSubmit}>
          {/* Full Name */}
          <div>
            <label htmlFor="full_name" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Full Name
            </label>
            <input
              id="full_name"
              name="full_name"
              type="text"
              required
              value={formData.full_name}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              placeholder="John Doe"
            />
          </div>

          {/* Gender - Minimal Select */}
          <div>
            <label htmlFor="gender" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Gender
            </label>
            <select
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent appearance-none"
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* Phone Number */}
          <div>
            <label htmlFor="phone_number" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Phone Number
            </label>
            <input
              id="phone_number"
              name="phone_number"
              type="tel"
              required
              value={formData.phone_number}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              placeholder="+1 234 567 8900"
            />
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              value={formData.email}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              placeholder="your@email.com"
            />
          </div>

          {/* Password */}
          <div>
            <label htmlFor="password" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={formData.password}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              placeholder="••••••••"
            />
          </div>

          {/* Confirm Password */}
          <div>
            <label htmlFor="confirm_password" className="block text-xs text-gray-400 uppercase tracking-wider mb-2">
              Confirm Password
            </label>
            <input
              id="confirm_password"
              name="confirm_password"
              type="password"
              required
              value={formData.confirm_password}
              onChange={handleChange}
              className="w-full px-0 py-2 text-sm text-gray-900 border-b border-gray-200 focus:outline-none focus:border-gray-900 transition bg-transparent"
              placeholder="••••••••"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full mt-6 py-3 text-sm font-medium tracking-wide text-white bg-gray-900 hover:bg-gray-800 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Creating account...' : 'Create account'}
          </button>
        </form>

        {/* Divider */}
        <div className="relative my-8">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-100"></div>
          </div>
          <div className="relative flex justify-center text-xs">
            <span className="px-3 bg-white text-gray-400">secure registration</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;